import { UseFormReturn } from "react-hook-form";


interface limpaCamposFormProps {
    methods: UseFormReturn<any>;
}

export const limpaCamposPsJuridica = ({ methods }: limpaCamposFormProps) => {
    methods.setValue("cnpj", "");
    methods.setValue("fantasyName", "");
    methods.setValue("corporateName", "");
    methods.setValue("address.zipCode", "");
    methods.setValue("address.neighborhood", "");
    methods.setValue("address.city", "");
    methods.setValue("address.state", "");
    methods.setValue("address.street", "");
    methods.setValue("email", "");
    methods.setValue("contact1", "");
    methods.setValue("contact2", "");
    methods.setValue("address.number", "");
    methods.setValue("address.complement", "");
}


export const limpaCamposPsFisica = ({ methods }: limpaCamposFormProps) => {
    methods.setValue("cpf", "");
    methods.setValue("fullName", "");
    methods.setValue("address.zipCode", "");
    methods.setValue("address.neighborhood", "");
    methods.setValue("address.city", "");
    methods.setValue("address.state", "");
    methods.setValue("address.street", "");
    methods.setValue("address.number", "");
    methods.setValue("address.complement", "");
    methods.setValue("email", "");
    methods.setValue("contact1", "");
    methods.setValue("contact2", "");
}